import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { V2ConfigurationContext } from 'contexts/Configuration'

import { Body1, DEFAULT_FONT_COLOR } from 'Text'

const Header = () => {
  const { t } = useTranslation()
  const { headerCopy, disableHeader } = useContext(V2ConfigurationContext)

  const headerLabel = headerCopy || t('buttonsHeader')

  if (disableHeader) return null

  return <HeaderText>{headerLabel}</HeaderText>
}

const HeaderText = styled(Body1)`
  width: fit-content;
  color: var(--sc-widget-header-color, ${DEFAULT_FONT_COLOR});
`

export default Header
